import {StoreInfoStatePhonesType} from 'desktop/types/storeInfoType';
import {HostApplicationStoreType} from 'hostApplicationStoreType';

/**
 * Retrieves the prescription email from the store information.
 * @param {HostApplicationStoreType} store - Host Application state
 * @returns {string} The prescription email address from host application state - storeInfo
 */
export const getPrescriptionEmail = (store: HostApplicationStoreType): string =>
    store.storeInfo.prescription_email;

/**
 * Retrieves the phone numbers from the host application state.
 * @param {HostApplicationStoreType} store - Host Application state.
 * @returns {StoreInfoStatePhonesType} An object containing the various phone numbers from host application state - storeInfo.
 */
export const getPhones = (store: HostApplicationStoreType): StoreInfoStatePhonesType =>
    store.storeInfo.phones;

/**
 * Retrieves the fax number from the host application state.
 * @param {HostApplicationStoreType} store - Host Application state
 * @returns {string} The fax number from host application state - storeInfo.
 */
export const getFax = (store: HostApplicationStoreType): string => store.storeInfo.fax;

/**
 * Get working hours
 * @param {ApplicationStoreType} store - Application state
 * @returns {string} working hours
 */
export const getWorkingHours = (store: HostApplicationStoreType): string => {
    return store.storeInfo.working_hours;
};
